import { useQuery } from 'react-query'
import { config } from 'config'
import { callAxios, CustomAxiosError } from 'utils/api'
import { UserRoles } from 'types/userRoles'
import { splitUserRoleType } from 'pages/admin/userRoles/utils/userRoles'

const { SECURE_BASE_URL } = config!

const getUserRoles = async (): Promise<UserRoles[]> => {
  const { response: userRolesResponse } = await callAxios<{
    response: UserRoles[]
  }>({
    url: `${SECURE_BASE_URL}/userRoles?operation=read`,
    method: 'GET',
  })

  const mappedResponse = userRolesResponse?.map((item) => {
    const sdhUserType = splitUserRoleType(item.sdhUserRoleType).sdhUserType
    const sdhUserRoleType = splitUserRoleType(item.sdhUserRoleType).sdhUserRoleType
    return { ...item, sdhUserType, sdhUserRoleType }
  })

  return mappedResponse
}

export const useGetUserRoles = () => {
  const {
    status: getUserRolesStatus,
    isFetching: getUserRolesLoading,
    data: userRolesData,
    error: getUserRolesError,
    refetch: fetchUserRoles,
  } = useQuery<UserRoles[], CustomAxiosError>(['userRoles/get'], () => getUserRoles())
  return {
    getUserRolesStatus,
    getUserRolesLoading,
    getUserRolesError,
    userRolesData,
    fetchUserRoles,
  }
}
